"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class GatewayTrustedDeviceUntrustRequest extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'gatewayTrustedDeviceUntrustRequest';
        this._assetCode = initParams.asset_code;
        this._gatewayId = initParams.gateway_id;
    }
    set assetCode(value) {
        console.error('Do not set objects this way');
    }
    get assetCode() {
        return this._assetCode;
    }
    set gatewayId(value) {
        console.error('Do not set objects this way');
    }
    get gatewayId() {
        return this._gatewayId;
    }
}
exports.default = GatewayTrustedDeviceUntrustRequest;
//# sourceMappingURL=gatewayTrustedDeviceUntrustRequest.js.map